import BaseApi from './BaseApi';

class BuildChannelApi extends BaseApi {
  async all() {
    const url = `${this.baseUrl}/evaluations/api/v1/build-channels`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return this.parseResponse(response);
  }
}

export default BuildChannelApi;
